export const toPrice = (num) => parseFloat(num).toFixed(2);

export const calculateTotalToPay = (itemsPrice, promoPrice, jackpotMatchAmount = 0) => {
  const isPromo = promoPrice < itemsPrice;
  const isJackpotMatch = jackpotMatchAmount > 0;

  if (isPromo) {
    if (isJackpotMatch) return Math.max(0,promoPrice - jackpotMatchAmount);
    return promoPrice;
  }

  if (isJackpotMatch) return Math.max(0,itemsPrice - jackpotMatchAmount);
  return toPrice(itemsPrice);
};

export const calculateTotalAddedToJackpot = (orderItems) => {
  let totalAddedToJackpot = 0;
  orderItems.forEach(item => {
    item.cashbackAmount = item.cashbackAmount || 0;
    
    totalAddedToJackpot += item.cashbackAmount * item.Qty;   
  });
  
  return totalAddedToJackpot;
}


export const getCashbackOfProduct = (item) => {
  return item.cashbackAmount * item.Qty;
}



